import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noprivilege',
  templateUrl: './noprivilege.component.html',
  styleUrls: ['./noprivilege.component.css']
})
export class NoprivilegeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
